
import { ICommonPensionInputs, IMonthlyPensionPayments, SimplePensionFormOfPayment } from 'app/calcs/pensions/interfaces'
import * as moment from 'moment'
import { Local697FormOfPayment } from '../../local697/interfaces'

enum NEBFFormOfPayment {
  lifeOnly = 300
  }

interface INEBFPensionInputs extends ICommonPensionInputs {
  beginPaymentsAge: moment.Duration
  formOfPayment: SimplePensionFormOfPayment | NEBFFormOfPayment | Local697FormOfPayment
  currentYearsService: moment.Duration
}

export {
  NEBFFormOfPayment,
  INEBFPensionInputs
}



// WEBPACK FOOTER //
// ./src/app/calcs/customers/NEBF/interfaces/index.ts